/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button } from "@/components/ui/button";
import { DialogFooter } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { useReactForm } from "../react-hook/use-react-form";
import { IconRender } from "@/components/shared/Icon-render";
import {
  ArrayInput,
  MultiSelectWithSearch,
  SelectWithSearch,
} from "@/components/form-input";
import { SelectInput } from "@/components/ui/select-input";
import { Switch } from "@/components/ui/switch";
import { RequiredInput } from "@/components/shared/required-input";
import { useWatch } from "react-hook-form";
import { useEffect, useState } from "react";
import {
  DATE_TYPES,
  SUPPORTED_DOCUMENT_LIST,
} from "@/global-data/global-const";
import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { /* BadgeInfo, BadgeInfoIcon, */ InfoIcon } from "lucide-react";
import { cn } from "@/lib/utils";
import { IgnoreKeysSelect } from "@/components/form-input/ignore-keys-select";
import { transformSchemaToOptions } from "../react-hook/utils";
import { DefaultUomSettings } from "../default-uom-settings/default-uom-settings";

type UserFormType = {
  formData: any;
  onOpenChange: (prop: any) => void;
  onFormSubmit: (prop: boolean) => Promise<void>;
  open: boolean;
  companyData: any;
  domainList: any;
  attributesList: any;
  defaultWorkflow: any;
  sncErpSku: any;
  loadSncErpSku: any;
};
export const ReactForm = ({
  formData,
  onOpenChange,
  onFormSubmit,
  open,
  domainList,
  attributesList,
  defaultWorkflow,
  sncErpSku,
  loadSncErpSku,
}: UserFormType) => {
  const { form, onSubmit } = useReactForm({
    formData,
    onOpenChange,
    onFormSubmit,
    open,
  });

  const [ignoreList, setIgnoreList] = useState<any>([]);

  const divide_doc_to_chunks = useWatch({
    control: form.control,
    name: "divide_doc_to_chunks",
  });
  const auto_generate_reference_no = useWatch({
    control: form.control,
    name: "auto_generate_reference_no",
    defaultValue: formData?.auto_generate_reference_no,
  });
  const is_equal_to_order_date = useWatch({
    control: form.control,
    name: "settings.delivery_date_settings.is_equal_to_order_date",
  });

  const today_date = useWatch({
    control: form.control,
    name: "settings.delivery_date_settings.today_date",
  });
  const synonymMapping = useWatch({
    control: form.control,
    name: "synonym_mapping",
  });

  useEffect(() => {
    if (today_date) {
      form.setValue(
        "settings.delivery_date_settings.is_equal_to_order_date",
        false,
      );
      form.setValue(
        "settings.delivery_date_settings.days_after_order_date",
        "",
      );
    }
  }, [today_date]);

  useEffect(() => {
    if (is_equal_to_order_date) {
      form.setValue(
        "settings.delivery_date_settings.days_after_order_date",
        "",
      );
      form.setValue("settings.delivery_date_settings.today_date", false);
    }
  }, [is_equal_to_order_date]);
  useEffect(() => {
    form.setValue(
      "settings.delivery_date_settings.is_equal_to_order_date",
      formData?.settings?.delivery_date_settings?.is_equal_to_order_date ||
        false,
    );
  }, [formData?.settings?.delivery_date_settings?.is_equal_to_order_date]);

  const synonym_mapping = useWatch({
    control: form.control,
    name: "synonym_mapping",
  });

  useEffect(() => {
    (async () => {
      if (open && sncErpSku.length === 0) {
        await loadSncErpSku();
      }
    })();
  }, [open]);

  useEffect(() => {
    const temp_list = attributesList?.find(
      (item: any) => item?.domain_name == synonym_mapping,
    );
    if (temp_list?.entities) {
      const newList: any = transformSchemaToOptions(temp_list?.entities) || [];
      setIgnoreList(newList);
    } else {
      setIgnoreList([]);
    }
  }, [attributesList, synonym_mapping]);

  useEffect(() => {
    if (formData?.synonym_mapping) {
      const temp_list = attributesList?.find(
        (item: any) => item?.domain_name == formData.synonym_mapping,
      );
      if (temp_list?.entities) {
        const newList: any =
          transformSchemaToOptions(temp_list?.entities) || [];
        setIgnoreList(newList);
      } else {
        setIgnoreList([]);
      }
    } else if (defaultWorkflow) {
      const temp_list = attributesList?.find(
        (item: any) => item?.domain_name == defaultWorkflow,
      );
      if (temp_list?.entities) {
        const newList: any =
          transformSchemaToOptions(temp_list?.entities) || [];
        setIgnoreList(newList);
      } else {
        setIgnoreList([]);
      }
    }
  }, [formData?.synonym_mapping, defaultWorkflow]);

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <div className="grid grid-cols-2 gap-x-6 gap-y-5 px-6">
          <FormField
            control={form.control}
            name="retailer_name"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Retailer name
                  <RequiredInput />
                </FormLabel>
                <FormControl>
                  <Input placeholder="Retailer name" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="retailer_code"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Retailer Code</FormLabel>
                <FormControl>
                  <Input placeholder="Retailer Code" {...field} />
                </FormControl>

                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="matching_keys"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Matching Keys</FormLabel>
                <FormControl>
                  <ArrayInput
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Matching Keys"
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />

          <div></div>

          <FormField
            control={form.control}
            name="synonym_mapping"
            defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Synonym mapping</FormLabel>
                <FormControl>
                  <SelectWithSearch
                    placeholder="Select Options"
                    bindLabel="label"
                    bindValue="value"
                    options={domainList}
                    value={field.value}
                    onChange={(prop: any) => {
                      field.onChange(prop);
                      form.setValue("settings.ignore_keys", [], {
                        shouldDirty: true,
                        shouldTouch: true,
                      });
                    }}
                    onBlur={field.onBlur}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          {divide_doc_to_chunks ||
          formData?.divide_doc_to_chunks ||
          synonymMapping ||
          synonym_mapping ? (
            <FormField
              control={form.control}
              name="child_doc_synonym_mapping"
              defaultValue=""
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Child doc synonym mapping</FormLabel>
                  <FormControl>
                    <SelectWithSearch
                      placeholder="Select Options"
                      bindLabel="label"
                      bindValue="value"
                      options={domainList}
                      value={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          ) : (
            <div></div>
          )}
          <FormField
            control={form.control}
            name="map_using_filename"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Map using filename</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="divide_doc_to_chunks"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Divide doc to chunks</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />

          <FormField
            control={form.control}
            name="auto_generate_reference_no"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Auto generate reference no</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />

          {auto_generate_reference_no ? (
            <FormField
              control={form.control}
              name="settings.po_number_prefix"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>PO Number Prefix</FormLabel>
                  <FormControl>
                    <Input placeholder="PO Number Prefix" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          ) : (
            <div className="min-h-[72px]"></div>
          )}

          <FormField
            control={form.control}
            name="settings.split_per_delivery_date"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Split per delivery date</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.split_consolidated_orders"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>split consolidated orders</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.ignore_validation_failure"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Ignore Validation Failure</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.cost_ctr_wise_split"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Cost ctr wise split</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
          {/* <FormField
            control={form.control}
            name="settings.multi_page_document"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Multi page document</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          /> */}

          <div className="col-span-2 mt-3">
            <hr />

            <span className="pt-3 inline-block w-full">
              Order date settings{" "}
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    className="-ml-2 translate-y-[2px] w-auto rounded-full bg-transparent hover:bg-transparent h-auto"
                  >
                    <InfoIcon />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="text-center">
                    If order date is not found, you can enable settings below to
                    define it.
                  </p>
                </TooltipContent>
              </Tooltip>
            </span>
          </div>

          <FormField
            control={form.control}
            name="settings.order_date_settings.today_date"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Today date</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.order_date_settings.is_equal_to_delivery_date"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Is equal to delivery date</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />

          <div className="col-span-2 mt-3">
            <hr />

            <span className="pt-3 inline-block w-full">
              Delivery Date Settings{" "}
              <Tooltip>
                <TooltipTrigger asChild>
                  <Button
                    variant="ghost"
                    className="-ml-2 translate-y-[2px] w-auto rounded-full bg-transparent hover:bg-transparent h-auto"
                  >
                    <InfoIcon />
                  </Button>
                </TooltipTrigger>
                <TooltipContent>
                  <p className="text-center">
                    If delivery date is not found, you can enable settings below
                    to define it.
                  </p>
                </TooltipContent>
              </Tooltip>
            </span>
          </div>

          <FormField
            control={form.control}
            name="settings.delivery_date_settings.days_after_order_date"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Days after order date</FormLabel>
                <div>
                  <FormControl>
                    <div className="relative">
                      <Input
                        disabled={is_equal_to_order_date}
                        type="string"
                        placeholder="Days after order date"
                        // value={field?.value}
                        // onChange={(e) =>
                        //   field.onChange(+e.target.value || undefined)
                        // }
                        inputMode="numeric"
                        pattern="[0-9]*"
                        value={field.value ?? ""}
                        onChange={(e) => {
                          const val = e.target.value;

                          const onlyNumbers = val.replace(/[^1-9]/g, "");

                          field.onChange(onlyNumbers);
                          // const num =
                          //   onlyNumbers === "" ? undefined : Number(onlyNumbers);

                          // const min = is_equal_to_order_date ? 0 : 1;

                          // if (num === undefined || num >= min) {
                          //   field.onChange(num);
                          // }
                        }}
                        onBlur={() => {
                          if (field.value === "") {
                            field.onChange(1);
                          }
                        }}
                      />
                      <Tooltip>
                        <TooltipTrigger
                          disabled={is_equal_to_order_date}
                          className={cn(
                            "absolute right-0 flex items-center justify-center top-0 h-full w-auto aspect-square",
                            is_equal_to_order_date ? "opacity-55" : "",
                          )}
                          type="button"
                        >
                          <InfoIcon size={16} />
                        </TooltipTrigger>
                        <TooltipContent
                          className={is_equal_to_order_date ? "hidden" : ""}
                        >
                          <TooltipArrow />
                          <p>It should be greater than 1</p>
                        </TooltipContent>
                      </Tooltip>
                    </div>
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
          <div className="grid grid-cols-2 ">
            <FormField
              control={form.control}
              name="settings.delivery_date_settings.is_equal_to_order_date"
              // defaultValue=""
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Is equal to order date</FormLabel>
                  <div>
                    <FormControl>
                      <Switch
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </FormControl>
                    <FormMessage />
                  </div>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="settings.delivery_date_settings.today_date"
              // defaultValue=""
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Today date</FormLabel>
                  <div>
                    <FormControl>
                      <Switch
                        checked={field.value}
                        onCheckedChange={field.onChange}
                      />
                    </FormControl>
                    <FormMessage />
                  </div>
                </FormItem>
              )}
            />
          </div>
          <FormField
            control={form.control}
            name="settings.order_date_format"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Order date format</FormLabel>
                <FormControl>
                  <SelectInput
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Order date format"
                    list={DATE_TYPES}
                    labelBind="label"
                    valueBind="value"
                    onBlur={field.onBlur}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.delivery_date_format"
            render={({ field }) => (
              <FormItem>
                <FormLabel>Delivery date format</FormLabel>
                <FormControl>
                  <SelectInput
                    value={field.value}
                    onChange={field.onChange}
                    placeholder="Delivery date format"
                    list={DATE_TYPES}
                    labelBind="label"
                    valueBind="value"
                    onBlur={field.onBlur}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.supported_document_types"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Supported document types
                  {/* <RequiredInput /> */}
                </FormLabel>
                <FormControl>
                  <MultiSelectWithSearch
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Supported document types"
                    options={SUPPORTED_DOCUMENT_LIST}
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    noLimit={true}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.ignore_keys"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  Ignore keys
                  {/* <RequiredInput /> */}
                </FormLabel>
                <FormControl>
                  <IgnoreKeysSelect
                    bindLabel="label"
                    bindValue="value"
                    placeholder="Ignore keys"
                    options={ignoreList}
                    value={field.value}
                    onChange={field.onChange}
                    onBlur={field.onBlur}
                    noLimit={true}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
          <FormField
            control={form.control}
            name="settings.branch_only_search"
            // defaultValue=""
            render={({ field }) => (
              <FormItem>
                <FormLabel>Branch only search</FormLabel>
                <div>
                  <FormControl>
                    <Switch
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                  </FormControl>
                  <FormMessage />
                </div>
              </FormItem>
            )}
          />
          <div className="grid grid-cols-2 ">
            <FormField
              control={form.control}
              name="settings.use_azure_ocr"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Use azure ocr</FormLabel>
                  <div>
                    <FormControl>
                      <Switch
                        checked={field.value}
                        onCheckedChange={(checked) => {
                          field.onChange(checked);
                          if (checked) {
                            form.setValue("settings.use_textract_ocr", false);
                          }
                        }}
                      />
                    </FormControl>
                    <FormMessage />
                  </div>
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name="settings.use_textract_ocr"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Use textract ocr</FormLabel>
                  <div>
                    <FormControl>
                      <Switch
                        checked={field.value}
                        onCheckedChange={(checked) => {
                          field.onChange(checked);
                          if (checked) {
                            form.setValue("settings.use_azure_ocr", false);
                          }
                        }}
                      />
                    </FormControl>
                    <FormMessage />
                  </div>
                </FormItem>
              )}
            />
          </div>
          <div className="col-span-full">
            <FormField
              control={form.control}
              name="settings.default_uom_settings"
              // defaultValue=""
              render={({ field }) => (
                <DefaultUomSettings
                  value={field?.value || []}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  sncErpSku={sncErpSku}
                />
              )}
            />
          </div>
        </div>
        <hr className="mt-5" />
        <DialogFooter className="p-6 flex !justify-start">
          <Button
            type="submit"
            className="w-[120px]"
            disabled={form.formState.isSubmitting}
          >
            {form.formState.isSubmitting ? (
              <IconRender
                name="LoaderCircle"
                className="w-5 animate-spin text-white zoom-in-150"
              />
            ) : (
              "Save"
            )}
          </Button>
          <Button
            type="submit"
            onClick={() => onOpenChange(false)}
            variant={"outline"}
            className="w-[120px]"
          >
            Close
          </Button>
        </DialogFooter>
      </form>
    </Form>
  );
};
